import Loading from '@components/loading';
import { HOURS_IN_MILLISECONDS } from '@utils/constants';
import { handleAction } from '@utils/router';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';

/**
 *
 * @param {Object} params
 * @param {import('../../payload-types').Alert|null} params.campaign
 * @returns
 */
export default function Campaign({campaign}) {
  const [show, setShow] = useState(true);
  const [loaded, setLoaded] = useState(false);

  if (typeof window === 'undefined' || ! campaign) {
    return null;
  }

  const cacheKey = `campaign_expires_${campaign.id || ''}`;

  const expires = 6 * HOURS_IN_MILLISECONDS;
  const data = window?.localStorage?.getItem(cacheKey);
  const skiped = data ? parseInt(data) : 0;

  // @ts-ignore
  const bannerImage = campaign?.banner ? (campaign.banner?.url || '') : '';
  const bannerUrl = campaign.action || '';

  if (skiped >= Date.now() || ! bannerImage) {
    return null;
  }

  const hideModal = () => {
    if (! loaded) {
      return;
    }

    setShow(false);
    window.localStorage.setItem(cacheKey, String(Date.now() + expires));
  };

  const onClick = () => {
    if (! bannerUrl) {
      return;
    }

    setLoaded(true);
    handleAction({action: bannerUrl, target: '_blank'});
  };

  return (
    <Modal className="campaign-modal" show={show} dialogClassName="modal-xl" onHide={ hideModal }>
      <Modal.Body className={ `text-center ${bannerUrl ? 'cursor-pointer' : ''}`} onClick={ onClick }>
        <Loading className="loading" size="xl" mode="override" />
        <div className="campaign-content">
          <img src={ bannerImage } style={{ maxWidth: '100%', maxHeight: '100%', height: 'auto', flexGrow: 0 }} onLoad={ () => setLoaded(true) }/>
        </div>
      </Modal.Body>
    </Modal>
  );
}
